import config from 'constants/apiConfig';
import axios from 'axios';

import downloadFile from 'utils/downloadFile';
import { noAutoClose } from 'assets/data/config';

import {
  EXPORT_FORM_TO_PDF_ERROR,
  EXPORT_FORM_TO_PDF_REQUEST,
  EXPORT_FORM_TO_PDF_SUCCESS,
} from 'constants/form-action-types';
import { toast } from 'react-toastify';

function exportFormToPDFRequest() {
  return {
    type: EXPORT_FORM_TO_PDF_REQUEST,
  };
}

function exportFormToPDFSuccess(exportedFormsToPDF) {
  return {
    type: EXPORT_FORM_TO_PDF_SUCCESS,
    payload: exportedFormsToPDF,
  };
}

function exportFormToPDFError(error) {
  const errorMessage =
    'exportFormToPDFError\n\n' +
    ((!!error &&
      !!error.message &&
      typeof error.message === 'string' &&
      error.message) ||
      '') +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: EXPORT_FORM_TO_PDF_ERROR,
  };
}

export const exportFormToPDF = (
  form,
  formconfig = null,
  isDownloading = false
) => {
  return (dispatch) => {
    dispatch(exportFormToPDFRequest());
    return axios(config.apiGateway.exportFormToPDF, {
      method: 'POST',
      data: JSON.stringify({
        form,
        config: formconfig,
      }),
    })
      .then((response) => {
        const statementAsDocumentFile = response.data || {};

        if (isDownloading)
          downloadFile(form.formname, 'PDF', statementAsDocumentFile);

        dispatch(
          exportFormToPDFSuccess({ ...form, PDFData: statementAsDocumentFile })
        );
        // toast.success('Export Form to PDF successful', {
        //   autoClose: 2000,
        // });
        return statementAsDocumentFile;
      })
      .catch((error) => {
        dispatch(exportFormToPDFError(error));
      });
  };
};

// NEW APPROACH
